<template>
  <th v-if="isHeader">
    {{rowField.title | translate}}
  </th>
  <td v-else>
  <div class="custom-actions">
      <input v-if="inputType(rowField.model).type == 'text'" :style="'width:' + (inputType(rowField.model).width ? inputType(rowField.model).width + 'px' : '100%')" type="text" class="form-control" @change="itemAction('update-field', rowData.id, rowField.model, rowData)" v-model="rowData[rowField.model]"></input>
      <input v-if="inputType(rowField.model).type == 'number'" :style="'width:' + (inputType(rowField).width ? inputType(rowField.model).width + 'px' : '100%')" type="number" class="form-control" @change="itemAction('update-field', rowData.id, rowField.model, rowData)" v-model="rowData[rowField.model]"></input>
      <select v-if="inputType(rowField.model).type == 'select' && rowField.model == 'unit_id'" :style="'width:' + (inputType(rowField.model).width ? inputType(rowField.model).width + 'px' : '100%')" class="form-control" @change="itemAction('update-field', rowData.id, rowField.model, rowData)" v-model="rowData[rowField.model]">
        <option v-for="wou in $store.getters.workOrderUnit" :value="wou.id">{{ wou.title }}</option>
      </select>
      <a href="#" v-if="inputType(rowField.model).type == 'delete'" @click.prevent="itemAction('delete-row', rowData.id, rowField.model, rowData)">x</a>
  </div>
  </td>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'

export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowData: {
      type: Object,
      required: false
    },
    rowField: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    inputType: (field) => {
      switch (field) {
        case 'delete':
          return {type: 'delete'}
        case 'comment':
          return {type: 'text'}
        case 'quantity':
          return {type: 'text', width: 55}
        case 'unit_id':
          return {type: 'select'}
        default:
          return {type: 'text', width: '100%'}
      }
    },
    itemAction (action, id, field, data) {
      this.$parent.$parent.$emit('data-changed', action, id, field, data)
    }
  }
}
</script>


// WEBPACK FOOTER //
// OrderLineCommentField.vue?48647245